import axios from 'axios';

const getAllDrivers = () => axios.get(`/live-chat/all`);

const getDriver = () => axios.get(`/live-chat/`);

const updateDriver = id => axios.put(`/live-chat/`, { id });

export { getAllDrivers, getDriver, updateDriver };
